import { storage } from '../services/storage';
import { waitForSystemCalendarOperations } from './systemCalendar';

export function isDeviceCalendarConnectionEnabled(userId: number) {
  return storage.getCalendarConnectionEnabled(userId);
}

export function enableDeviceCalendarConnection(userId: number) {
  return storage.setCalendarConnectionEnabled(userId, true);
}

export async function disconnectDeviceCalendarConnection(userId: number) {
  // Önce yeni okuma/yazmaları kapat, sonra başlamış sistem takvimi işlemlerinin
  // bitmesini bekle. Böylece bağlantı kesildikten sonra yeni eşleme kalmaz.
  await storage.setCalendarConnectionEnabled(userId, false);
  await waitForSystemCalendarOperations(userId);
  await Promise.all([
    storage.setSelectedCalendarIds(userId, []),
    storage.clearSystemCalendarEventsForUser(userId),
  ]);
}
